import cx from 'classnames'
import { useContext } from 'react'

import { ProductCollectionQuickFilterContext } from '@lib/product-collection-quick-filter-context'
import { StringsContext } from '@lib/strings-context'

import CollectionQuickFilterOption from './quick-filter-option'

const CollectionQuickFilter = () => {
  const {
    quickFilterEnabled,
    quickFilterSelectedValue,
    quickFilterOptions,
    setQuickFilterValue,
  } = useContext(ProductCollectionQuickFilterContext)
  const strings = useContext(StringsContext)

  if (!quickFilterEnabled || quickFilterOptions.length === 0) {
    return null
  }

  return (
    <div
      className={cx(
        'container flex items-center justify-start gap-4 py-3.5',
        'border-b border-gray bg-pageBG bg-opacity-95',
        'overflow-x-auto no-scrollbar',
      )}
    >
      <button
        onClick={() => setQuickFilterValue(null)}
        className={cx('text-xs uppercase leading-none', {
          'text-gray-dark': quickFilterSelectedValue !== null,
        })}
      >
        {strings.collectionQuickFilterAllLabel}
      </button>

      {quickFilterOptions.map((quickFilterOption) => (
        <CollectionQuickFilterOption
          key={quickFilterOption.value}
          isActive={quickFilterSelectedValue === quickFilterOption.value}
          onClick={() => setQuickFilterValue(quickFilterOption.value)}
        >
          {quickFilterOption.title}
        </CollectionQuickFilterOption>
      ))}
    </div>
  )
}

export default CollectionQuickFilter
